import axios from 'axios';

import type { getVirtualTourByRoomDTO } from '@bb/domain/dist/types/dto/VirtualTourController/getVirtualTourByRoom';

const getVirtualTourByRoom = async (roomId: string) => {
  const { data } = await axios.get<getVirtualTourByRoomDTO>(
    `/virtual_tour_by_room/${roomId}`,
  );

  return data;
};

export default getVirtualTourByRoom;
